import React from "react";
import "../components/componentstyle/eventData.css";
import SharedEventGallery from "./SharedEventGallery";

function EventData() {
  return <SharedEventGallery className="event" title="Event" />;
}

export default EventData;
